import { Trans } from '@lingui/macro'
import { Alert, AlertTitle } from '@mui/material'
import routes from 'app/RootRoutes'
import { setPortalTranslationConfig } from 'app/redux/actions/PortalTranslationActions'
import { getPortalTranslationConfig } from 'app/services/sfAuth/sfData/sfPortalTranslationConfiguration'
import { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { languages } from 'translation/I18nConnectedProvider'
import { matchPath } from 'react-router-dom'

export const PortalTranslationWarningBar = ({
  portalTranslationConfig,
  user
}) => {
  const dispatch = useDispatch()

  const location = useLocation()

  const { pathname } = location

  const unitedPortalTranslationConfig = Object.keys(
    portalTranslationConfig
  ).reduce((acc, group) => {
    acc = [...acc, ...portalTranslationConfig[group]]
    return acc
  }, [])

  const route = unitedPortalTranslationConfig.find(r =>
    matchPath(pathname, {
      path: r.path,
      exact: true,
      strict: false
    })
  )

  const lang = user?.language?.split('_')[0] || 'en'

  useEffect(() => {
    if (user) {
      const initGroupRouteObj = getGroupRouteObj()
      getPortalTranslationConfig().then(result => {
        const _groupRouteObj = Object.keys(initGroupRouteObj).reduce(
          (acc, group) => {
            acc[group] = initGroupRouteObj[group].map(route => {
              try {
                const _route = result?.find(r => r.path === route.path)
                if (_route) {
                  route.translatedFor = _route.translatedFor
                  return route
                }
                return route
              } catch (e) {
                return route
              }
            })
            return acc
          },
          {}
        )
        dispatch(setPortalTranslationConfig(_groupRouteObj))
      })
    }
  }, [user])

  if (!route?.translatedFor?.[lang]?.value && route?.isTranslatable) {
    return (
      <Alert severity='info'>
        <AlertTitle>
          <Trans>NOT_SUPPORTED_LANGUAGE</Trans>
        </AlertTitle>
      </Alert>
    )
  }

  return null
}

const mapStateToProps = state => ({
  portalTranslationConfig: state.portalTranslationConfig,
  user: state.user
})

export default connect(mapStateToProps)(PortalTranslationWarningBar)

function getGroupRouteObj () {
  const groupRouteObj = {}
  routes.forEach(route => {
    const group = route.path?.split('/')[1]
    if (group && route.isTranslatable) {
      const _route = {
        ...route,
        translatedFor: languages.reduce((acc, lang) => {
          acc[lang] = { value: false }
          return acc
        }, {})
      }
      _route.label = route.label || route.path
      if (groupRouteObj[group]) {
        groupRouteObj[group].push(_route)
      } else {
        groupRouteObj[group] = [_route]
      }
    }
  })
  return groupRouteObj
}
